import React, { useState, useRef, useEffect } from 'react';

import DropDown from "../../../../../ui/DropDown";
import RadioButton from "../../../../../ui/RadioButton";
import Button from "../../../../../ui/Button";

import { filterIcon } from "../../../../../../utils/icons";

import "./index.scss";

const newFindingsOption = [    
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const statusOption = [    
    {
        label: "Open",
        value: "open"
    },
    {
        label: "Closed",
        value: "closed"
    },
    {
        label: "Won't Fix",
        value: "Wont_fix"
    }
]

const SeverityOption = [
    {
        label: "Critical",
        value: "critical"
    },
    {
        label: "High",
        value: "high"
    },
    {
        label: "Medium",
        value: "medium"
    },
    {
        label: "Low",
        value: "low"
    },
    {
        label: "Informational",
        value: "informational"
    },
    {
        label: "Unknown",
        value: "unknown"
    },
]

const riskOption = [  
    {
        label: "Potential",
        value: "potential"
    },
    {
        label: "Confirmed",
        value: "confirmed"
    },
]

const emailStatusOption = [
    {
        label: "Active",
        value: "active"
    },
    {
        label: "Inactive",
        value: "inactive"
    },
    {
        label: "All",
        value: "all"
    },
]

const ListFilter = ({listFilterApply, listFilterValue, currentPage="default"}) => {

    const filterWrapperRef = useRef(null);

    // list filter
    const [showFilter, setShowFilter] = useState(false);
    const [listNewFindings, setListNewFindings] = useState("");
    const [listStatusSelected, setListStatusSelected] = useState("");
    const [listSeveritySelected, setListSeveritySelected] = useState("");
    const [listRiskSelected, setListRiskSelected] = useState("");
    const [listEmailStatus, setListEmailStatus] = useState("");
    const [inputRangeValue, setInputRangeValue] = useState(50);

    const applyFilter = () => {
        let obj = {
            newFindings: listNewFindings ? newFindingsOption.find((data) => data.value === listNewFindings) : {},
            status: listStatusSelected ? statusOption.find((data) => data?.value === listStatusSelected) : {},
            severity: listSeveritySelected ? SeverityOption.find((data) => data?.value === listSeveritySelected) : {},
            risk: listRiskSelected ? riskOption.find((data) => data.value === listRiskSelected) : {},
            emailStatus: listEmailStatus ? emailStatusOption.find((data) => data.value === listEmailStatus) : {}
        }
        listFilterApply(obj)
        setShowFilter(false);
    }

    useEffect(()=>{
        setListNewFindings(listFilterValue?.newFindings?.value || "")
        setListStatusSelected(listFilterValue?.status?.value || "")
        setListSeveritySelected(listFilterValue?.severity?.value || "")
        setListRiskSelected(listFilterValue?.risk?.value || "")
        setListEmailStatus(listFilterValue?.emailStatus?.value || "")
    },[listFilterValue])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }        
        }
    },[showFilter])

    return (
        <>
            <div className="position-relative">
                <span className="filter-icon" onClick={()=>{setShowFilter(true)}}>{filterIcon()}</span>
                {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                    <h6>New Findings</h6>
                    <div className="filter-user-status d-flex mb-4 gap-4">
                        {
                            newFindingsOption.map((data,index)=>{
                                return (
                                    <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setListNewFindings(value)}} key={index} isChecked={data.value === listNewFindings} />
                                )
                            })
                        }
                    </div>
                    {
                        currentPage !== "leakedCredentials" && currentPage !== "botnetLeaks" && currentPage !== "ransomwareGroup" && currentPage !== "similarDomain" && currentPage !== "doaminSimilarities" &&
                        <>
                            <h6>Status</h6>
                            <div className="filter-user-status d-flex mb-4 gap-4">
                                {
                                    statusOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setListStatusSelected(value)}} key={index} isChecked={data.value === listStatusSelected} />
                                        )
                                    })
                                }
                            </div>
                        </>
                    }                    
                    {
                        currentPage === "leakedCredentials" &&
                        <>
                            <h6>Email Status</h6>
                            <div className="filter-user-status d-flex mb-4 gap-4">
                                {
                                    emailStatusOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={`Email`+ data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setListEmailStatus(value)}} key={index} isChecked={data.value === listEmailStatus} />
                                        )
                                    })
                                }
                            </div>
                        </>
                    }
                    {
                        currentPage === "subdomainTakeover" &&
                        <>
                            <h6>Risk</h6>
                            <div className="filter-user-status d-flex mb-4 gap-4">
                                {
                                    riskOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setListRiskSelected(value)}} key={index} isChecked={data.value === listRiskSelected} />
                                        )
                                    })
                                }
                            </div>
                        </>
                    }
                    {
                        currentPage === "default" && 
                        <>
                            <h6>Severity</h6>
                            <DropDown 
                                placeHolder={"Severity"}
                                options={SeverityOption}
                                isMulti={false}
                                isSearchable={false}
                                onChange={(data)=>{setListSeveritySelected(data.value)}}
                                defaultSelectedValue={listSeveritySelected}
                            />
                        </>
                    }
                    {
                        currentPage === "doaminSimilarities" &&
                        <>
                            <h6>Similarity: {inputRangeValue}%</h6>
                            <div className="input-range-container">
                                <input
                                    type="range"
                                    min="0"
                                    max="100"
                                    value={inputRangeValue}
                                    onChange={(e)=>setInputRangeValue(e.target.value)}
                                    className="slider"
                                    style={{
                                        background: `linear-gradient(to right, #00308B ${inputRangeValue}%, #ddd ${inputRangeValue}%)`
                                    }}
                                />
                                <div className="d-flex align-items-center justify-content-between input-range mt-1">
                                    <p className="value-text">0%</p>
                                    <p className="value-text">20%</p>
                                    <p className="value-text">40%</p>
                                    <p className="value-text">60%</p>
                                    <p className="value-text">80%</p>
                                    <p className="value-text">100%</p>
                                </div>
                            </div>
                        </>                        
                    }
                    
                    <div className="filter-apply-btn mt-3">
                        <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={false} buttonClicked={()=>{applyFilter()}}/>
                    </div>
                </div>}
            </div>
        </>
    )
}

export default ListFilter;